import { useState } from "react";
import { ChevronRight, Sparkles } from "lucide-react";

export function ExpandableThought({
  time,
  content,
}: {
  time: string;
  content: string;
}) {
  const [expanded, setExpanded] = useState(false);
  return (
    <div className="mb-4 bg-white border border-gray-100 rounded-xl overflow-hidden shadow-sm">
      <button
        onClick={() => setExpanded(!expanded)}
        className="flex items-center justify-between w-full px-4 py-2.5 text-[14px] font-semibold text-gray-600 hover:bg-gray-50 transition-colors"
      >
        <div className="flex items-center gap-2">
          <Sparkles size={16} className="text-blue-500" />
          <span>Thought for {time}</span>
        </div>
        <ChevronRight
          size={16}
          className={`transition-transform duration-200 ${expanded ? "rotate-90" : ""}`}
        />
      </button>
      {expanded && (
        <div className="px-4 pb-3 pt-1 border-t border-gray-50 text-sm text-gray-500 bg-gray-50/30">
          {content}
        </div>
      )}
    </div>
  );
}
